import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  ToggleBillToPArent,
  ToggleBillToPArentVariables
} from '@/graphql/contracts/_generated_/toggleBillToParent.mutation';
import ToggleBillToParentMutation from '@/graphql/contracts/toggleBillToParent.mutation.gql';
import GetContractDetailsQuery from '@/graphql/contracts/getContractDetails.query.gql';
import { notificationService } from '@/services/notification/notification.client';

export default function useToggleBillToParent(contractId: UUID) {
  const [_toggleBillToParent, { loading }] = useMutation<ToggleBillToPArent, ToggleBillToPArentVariables>(
    ToggleBillToParentMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetContractDetailsQuery,
          variables: {
            contractId,
          }
        }
      ],
      onCompleted: ({ toggleBillToParent }) => {
        notificationService.open({
          title: 'Bill to parent',
          text: toggleBillToParent?.billToParent
            ? 'Bill to parent successfully enabled'
            : 'Bill to parent successfully disabled',
          type: 'success'
        });
      }
    }
  );

  const toggleBillToParent = (billToParent: boolean) => {
    return _toggleBillToParent({
      variables: {
        billToParent,
        contractId
      }
    }).then(result => result.data);
  };

  return {
    toggleBillToParent,
    isLoadingToggleBillToParent: loading
  } as const;
}
